import * as React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import TranslateIcon from '@mui/icons-material/Translate';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import MapIcon from '@mui/icons-material/Map';
import HomeIcon from '@mui/icons-material/Home';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HvacIcon from '@mui/icons-material/Hvac';
import { EnergySavingsLeaf, ExpandMore, SensorOccupied } from '@mui/icons-material';
import TimelineIcon from '@mui/icons-material/Timeline';
import ReportIcon from '@mui/icons-material/Report';
import LogoutIcon from '@mui/icons-material/Logout';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Link } from 'react-router-dom';
import logo from '../logo.png';
import { useTranslation } from "react-i18next";
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';

import { useLocation } from 'react-router-dom'
import Savings from '@mui/icons-material/Savings';


const SideMenu = (props) => {

  const { onLogout, onLanguageChange, hiddenPages, language } = props;

  const languages = ["en", "tr"]

  const { t } = useTranslation();

  const location = useLocation();

  const [managementOpen, setManagementOpen] = React.useState(true);
  const [analysisOpen, setAnalysisOpen] = React.useState(true);


  return <React.Fragment>
    <Toolbar>
      <Box sx={{ width: "100%" }}>
        <img src={logo} width="100%" alt="XWatts" />
      </Box>
    </Toolbar>
    <Divider />
    <List>
      <ListItemButton onClick={() => setManagementOpen(!managementOpen)}>
        <ListItemIcon>
          <TuneIcon />
        </ListItemIcon>
        <ListItemText primary={t("Management")} />
        {managementOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={managementOpen} timeout="auto" unmountOnExit>
        <List sx={{ pl: 2 }}>
          <ListItem disablePadding>
            <ListItemButton component={Link} to="/status" selected={location.pathname === "/status"}>
              <ListItemIcon>
                <MapIcon />
              </ListItemIcon>
              <ListItemText primary={t("Status")} />
            </ListItemButton>
          </ListItem>
          {!hiddenPages.includes("automation") &&
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/automation" selected={location.pathname === "/automation"}>
                <ListItemIcon>
                  <CalendarMonthIcon />
                </ListItemIcon>
                <ListItemText primary={t("Automation")} />
              </ListItemButton>
            </ListItem>
          }
          {!hiddenPages.includes("alerts") &&
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/alerts" selected={location.pathname === "/alerts"}>
                <ListItemIcon>
                  <ReportIcon />
                </ListItemIcon>
                <ListItemText primary={t("Alerts")} />
              </ListItemButton>
            </ListItem>
          }
        </List>
      </Collapse>
      <ListItemButton onClick={() => setAnalysisOpen(!analysisOpen)}>
        <ListItemIcon>
          <SearchIcon />
        </ListItemIcon>
        <ListItemText primary={t("Analysis")} />
        {analysisOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={analysisOpen} timeout="auto" unmountOnExit>
        <List sx={{ pl: 2 }}>
          {!hiddenPages.includes("metering") &&
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/metering" selected={location.pathname === "/metering"}>
                <ListItemIcon>
                  <ElectricBoltIcon />
                </ListItemIcon>
                <ListItemText primary={t("Metering")} />
              </ListItemButton>
            </ListItem>
          }
          {!hiddenPages.includes("trends") &&
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/trends" selected={location.pathname === "/trends"}>
                <ListItemIcon>
                  <TimelineIcon />
                </ListItemIcon>
                <ListItemText primary={t("Trends")} />
              </ListItemButton>
            </ListItem>
          }
          {!hiddenPages.includes("savings") &&
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/savings" selected={location.pathname === "/savings"}>
                <ListItemIcon>
                  <EnergySavingsLeaf />
                </ListItemIcon>
                <ListItemText primary={t("Savings")} />
              </ListItemButton>
            </ListItem>
          }
          {
            !hiddenPages.includes("occupancy") &&
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/occupancy" selected={location.pathname === "/occupancy"}>
                <ListItemIcon>
                  <SensorOccupied />
                </ListItemIcon>
                <ListItemText primary={t("Occupancy")} />
              </ListItemButton>
            </ListItem>
          }

        </List>
      </Collapse>

    </List>
    <Divider />
    <List>
      <ListItem disablePadding>
        <ListItemButton component={Link} to="/settings" selected={location.pathname === "/settings"}>
          <ListItemIcon>
            <HvacIcon />
          </ListItemIcon>
          <ListItemText primary={t("Settings")} />
        </ListItemButton>
      </ListItem>
      <ListItem >
        <ListItemIcon>
          <TranslateIcon />
        </ListItemIcon>
        <FormControl size="small" variant="standard">
          <Select value={language} onChange={(event) => onLanguageChange(event.target.value)}>
            {
              languages.map((item) => (
                <MenuItem key={item} value={item}>
                  {t(item)}
                </MenuItem>
              ))
            }
          </Select>
        </FormControl>

      </ListItem>
      <ListItem disablePadding>
        <ListItemButton onClick={() => onLogout()}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary={t("Log out")} />
        </ListItemButton>
      </ListItem>
    </List>
  </React.Fragment>

}

export default SideMenu;